import React from "react";

import { Container } from "react-bootstrap";

export default function WouldYouText() {
  return (
    <Container fluid className="p-0 mt-2 ps-3">
      <h6>Would you rather:</h6>
    </Container>
  );
}
